import { Routes, Route, Outlet, Navigate, useLocation } from 'react-router-dom';
import './App.scss';
import { Box, IconButton, useMediaQuery } from '@mui/material';
import styled from '@emotion/styled';
import Protegido from 'services/auth/Protegido';
import Publico from 'services/auth/Publico';

import NavBar from 'components/public/NavBar/NavBar';
import Footer from 'components/public/Footer/Footer';
import MenuDrawer from 'components/public/MenuDrawer/MenuDrawer';
import BotonWhatsApp from 'components/public/BotonWhatsApp/BotonWhatsApp';

import Home from 'pages/public/Home';
import QuienesSomos from 'pages/public/QuienesSomos';
import Galeria from 'pages/public/Galeria';
import Alquiler from 'pages/public/Alquiler';
import HaceteSocio from 'pages/public/HaceteSocio';
import Contacto from 'pages/public/Contacto';
import Registro from 'pages/public/Registro';
import Login from 'pages/public/Login';
import Perfil from 'pages/usuario/Perfil';
import Dashboard from 'pages/admin/Dashboard';

import 'assets/fonts/SukhumvitSet-Medium.ttf';
import 'assets/fonts/SukhumvitSet-Bold.ttf';
import 'assets/fonts/SukhumvitSet-Light.ttf';
import Alquileres from 'components/admin/Listados/Alquileres/Alquileres';
import AltaEspectaculo from 'components/admin/AltaEspectaculo/AltaEspectaculo';
import AltaTaller from 'components/admin/AltaTaller/AltaTaller';
import Boletin from 'components/admin/Boletin/Boletin';
import Ventas from 'components/admin/Ventas/Ventas';
import FormBaja from 'components/usuario/FormBaja/FormBaja';
import FormUsuario from 'components/public/FormUsuario/FormUsuario';
import Usuarios from 'components/admin/Listados/Usuarios/Usuarios';
import AltaAlquiler from 'components/admin/AltaAlquiler/AltaAlquiler';
import Espectaculos from 'components/admin/Listados/Espectaculos/Espectaculos';
import Talleres from 'components/admin/Listados/Talleres/Talleres';
import FichaEspectaculo from 'components/public/FichaEspectaculo/FichaEspectaculo';
import AltaFunciones from 'components/admin/AltaEspectaculo/AltaFunciones';
import CompraEntrada from 'components/usuario/CompraEntrada/CompraEntrada';
import EdicionEspectaculo from 'components/admin/AltaEspectaculo/EdicionEspectaculo';
import DatosCuenta from 'pages/usuario/DatosCuenta';
import NotFound from 'pages/auxiliares/NotFound';
import SuccessCompra from 'pages/auxiliares/SuccessCompra';
import FailCompra from 'pages/auxiliares/FailCompra';
import { useEffect, useState } from 'react';
import { getAuthToken, setupInterceptors } from 'services/apiUtils';
import { useError } from 'services/ErrorContext';
import Alerta from 'components/public/Alerta.tsx/Alerta';
import Descuentos from 'components/admin/Descuentos/Descuentos';
import Generos from 'components/admin/Generos/Generos';
import GaleriaEspectaculo from 'components/public/GaleriaEspectaculo/GaleriaEspectaculo';
import EdicionTaller from 'components/admin/AltaTaller/EdicionTaller';
import FichaTaller from 'components/public/FichaTaller/FichaTaller';
import InscripcionTaller from 'components/public/FichaTaller/InscripcionTaller';
import GaleriaTalleres from 'pages/public/GaleriaTalleres';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'utils/redux/store/store';
import { resetAuthFlags } from '../../utils/redux/features/authSlice';
import CompraAdmin from 'components/admin/CompraAdmin/CompraAdmin';
import PendingCompra from 'pages/auxiliares/PendingCompra';
import useCheckSessionExpiration from 'utils/hooks/useChequearExpiracion';
import useSessionTimeout from 'utils/hooks/useSessionTimeOut';
import ConfirmacionRegistro from 'components/public/ConfirmacionRegistro/ConfirmacionRegistro';
import RestablecerPassSolicitud from 'components/public/Password/RestablecerPassSolicitud';
import ActualizarPass from 'components/public/Password/ActualizarPass';
import MisTalleres from 'components/admin/Listados/MisTalleres/MisTalleres';
import MisCompras from 'components/admin/Listados/MisCompras/MisCompras';
import Compras from 'components/admin/Listados/Compras/Compras';
import InscriptosTaller from 'components/admin/Listados/InscriptosTaller/InscriptosTaller';
import Cuotas from 'components/admin/Descuentos/Cuotas';
import PoliticasPrivacidadDatos from 'pages/public/PoliticasPrivacidadDatos';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import Tooltip from '@mui/material/Tooltip';
import { theme } from 'theme/theme';
import { anchoMaxLogueado, anchoMaxLogueadoMenuAbierto } from 'utils/constants';
import { toggleDrawer } from 'utils/redux/features/UISlice';
import NotAllowed from 'pages/auxiliares/NotAllowed';
import Boletines from 'components/admin/Listados/Boletines/Boletines';
import ErrorBoundary from 'components/public/ErrorBoundary/ErrorBoundary';

const Container = styled(Box)`
  font-family: 'SukhumvitSet-Medium';
`;

const BasicLayout = () => {
  return (
    <Box className="layout">
      <NavBar />
      <Box className="outletContainer">
        <Outlet />
        <Footer />
      </Box>
    </Box>
  );
};

const LogueadoLayout = () => {
  const [drawerOpen, setDrawerOpen] = useState(true);
  const dispatch = useDispatch();
  const listado = useSelector((state: RootState) => state.ui.listado);

  const handleToggleDrawer = () => {
    dispatch(toggleDrawer());
    setDrawerOpen(!drawerOpen);
  };

  const label = drawerOpen ? 'Cerrar menú' : 'Abrir menú';
  const versionMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    if (versionMobile) setDrawerOpen(false);
  }, [versionMobile]);

  const anchoMax = () => {
    if (!listado) {
      if (drawerOpen) {
        return anchoMaxLogueadoMenuAbierto;
      } else {
        return anchoMaxLogueado;
      }
    }
  };

  return (
    <Box className="layoutLogueado">
      <NavBar />
      <Box zIndex="10" pl={drawerOpen ? '240px' : '60px'} maxWidth={anchoMax} mx={listado ? '0' : 'auto'}>
        <MenuDrawer drawerWidth={260} open={drawerOpen} />
        {!versionMobile && (
          <Tooltip
            children={
              <IconButton
                onClick={handleToggleDrawer}
                sx={{
                  alignSelf: drawerOpen ? 'flex-end' : 'center',
                  position: 'absolute',
                  left: drawerOpen ? '200px' : '70px',
                  top: '156px',
                  backgroundColor: theme.palette.secondary.contrastText,
                  zIndex: 9999999,
                }}
              >
                {drawerOpen ? <ChevronLeft /> : <ChevronRight />}
              </IconButton>
            }
            title={label}
          />
        )}
        <Outlet />
      </Box>
    </Box>
  );
};

const App = () => {
  const [tokenExpirado, setTokenExpirado] = useState(false);
  const token = getAuthToken();
  const location = useLocation();
  const { clearError, error, setLoading } = useError();
  const [mensajeAuth, setMensajeAuth] = useState('');
  const authError = useSelector((state: RootState) => state.auth.authError);

  const { recienLogueado, recienDeslogueado } = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch();

  useSessionTimeout(); // Registra la última actividad
  useCheckSessionExpiration(); // Valida la expiración de la sesión

  useEffect(() => {
    if (recienDeslogueado) {
      setMensajeAuth('Te has deslogueado con éxito');
    }
    if (recienLogueado || recienDeslogueado) {
      dispatch(resetAuthFlags());
    }
  }, [recienLogueado, recienDeslogueado, dispatch]);

  if (token) {
    setupInterceptors();
  }

  useEffect(() => {
    clearError();
    setLoading(false);
    if (localStorage.getItem('tokenExpirado')) setTokenExpirado(true);
    return () => {
      setTokenExpirado(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, location.pathname]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const errorAuth = authError || 'Tu sesión ha expirado';

  return (
    <Container className="fluid-container" height="100%">
      <Alerta
        mensaje={errorAuth}
        abierto={!!authError || (tokenExpirado && !!error)}
        severity="error"
        duracion={null}
      />
      <Alerta mensaje={mensajeAuth} abierto={!!mensajeAuth} severity={'success'} duracion={null} />

      <ErrorBoundary>
      <Routes>
        <Route path="/" element={<BasicLayout />}>
          <Route index element={<Home />} />
          <Route path="inicio" element={<Navigate to="/" />} />
          <Route path="quienes-somos" element={<QuienesSomos />} />
          <Route path="galeria" element={<Galeria />} />
          <Route path="galeria/:id" element={<GaleriaEspectaculo botonVolver />} />
          <Route path="galeria-talleres" element={<GaleriaTalleres />} />
          <Route path="alquiler-de-salas" element={<Alquiler />} />
          <Route path="hacete-socio" element={<HaceteSocio />} />
          <Route path="contacto" element={<Contacto />} />
          <Route path="politicas" element={<PoliticasPrivacidadDatos />} />
          <Route path="registro" element={<Publico element={<Registro />} />} />
          <Route path="login" element={<Publico element={<Login />} />} />
          <Route path="espectaculos/:id" element={<FichaEspectaculo />} />
          <Route path="taller/:id" element={<FichaTaller />} />
          <Route path="taller/:id/inscripcion/" element={<InscripcionTaller />} />
          <Route path="/confirm" element={<ConfirmacionRegistro />} />
          <Route path="/restablecer" element={<RestablecerPassSolicitud />} />
          <Route path="/reset" element={<ActualizarPass />} />
          <Route path="unauthorized" element={<NotAllowed />} />
          <Route path="*" element={<NotFound />} />
        </Route>

        <Route element={<Protegido roles={['Administrador']} />}>
          <Route path="/admin" element={<LogueadoLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="unauthorized" element={<NotAllowed />} />
            <Route path="usuarios" element={<Usuarios />} />
            <Route path="alquileres" element={<Alquileres />} />
            <Route path="talleres" element={<Talleres />} />
            <Route path="espectaculos" element={<Espectaculos />} />
            <Route path="ventas" element={<Compras />} />
            <Route path="ganancia" element={<Ventas />} />
            <Route path="boletines" element={<Boletines />} />
            <Route
              path="/admin/usuarios/:id"
              element={
                <FormUsuario titulo="Edición de usuario" variante="edicionCatsUsuDesdeAdmin" textoBoton="Actualizar" />
              }
            />
            <Route path="/admin/usuarios/baja/:id" element={<FormBaja />} />
            <Route
              path="alta-usuario"
              element={
                <FormUsuario
                  titulo="Registrar nuevo usuario"
                  variante="registroUsuDesdeAdmin"
                  textoBoton="Registrar usuario"
                />
              }
            />
            <Route
              path="/admin/alquileres/:id"
              element={<AltaAlquiler titulo="Editar alquiler" variante="edicion" textoBoton="Actualizar" />}
            />
            <Route path="alta-taller" element={<AltaTaller titulo="Registrar nuevo taller" textoBoton="Registrar" />} />
            <Route
              path="alta-alquiler"
              element={
                <AltaAlquiler titulo="Registrar nuevo alquiler" variante="registro" textoBoton="Registrar alquiler" />
              }
            />
            <Route
              path="/admin/talleres/:id"
              element={<EdicionTaller titulo="Editar taller" textoBoton="Actualizar" />}
            />
            <Route path="/admin/talleres/:id/inscriptos" element={<InscriptosTaller />} />
            <Route path="/admin/alquiler/:id/eliminar" element={<FormBaja />} />
            <Route path="alta-espectaculo" element={<AltaEspectaculo />} />
            <Route path="/admin/espectaculos/:id" element={<EdicionEspectaculo />} />
            <Route
              path="/admin/espectaculos/:id/funciones"
              element={<AltaFunciones titulo="Agregar funciones al espectáculo" textoBoton="Registrar" />}
            />
            <Route path="elegir-espectaculo" element={<CompraAdmin />} />
            <Route path="boletin" element={<Boletin />} />
            <Route path="descuentos" element={<Descuentos />} />
            <Route path="cuotas" element={<Cuotas />} />
            <Route path="generos" element={<Generos />} />
            {/* <Route path="editar-tipo-elenco" element={<EditarTipoElenco />} /> */}
          </Route>
        </Route>

        <Route element={<Protegido roles={['Administrador', 'Cliente']} />}>
          <Route path="payment" element={<BasicLayout />}>
            <Route path="success" element={<SuccessCompra />} />
            <Route path="pending" element={<PendingCompra />} />
            <Route path="failure" element={<FailCompra />} />
          </Route>

          <Route path="/espectaculos/:id/compra" element={<BasicLayout />}>
            <Route path="/espectaculos/:id/compra/:id" element={<CompraEntrada />} />
          </Route>

          <Route path="/usuario" element={<LogueadoLayout />}>
            <Route index element={<Perfil />} />
            <Route path="editar" element={<DatosCuenta />} />
            <Route path="baja" element={<FormBaja />} />
            <Route path="mistalleres" element={<MisTalleres />} />
            <Route path="miscompras" element={<MisCompras />} />
            <Route path="password" element={<ActualizarPass />} />
            <Route path="unauthorized" element={<NotAllowed />} />
          </Route>
        </Route>
      </Routes>
      </ErrorBoundary>
      <BotonWhatsApp />
    </Container>
  );
};

export default App;
